<div class="header">
    <div class="logo logo-dark flex justify-center items-center">
        <a [routerLink]="'dashboard/home'">
            <img src="assets/images/logo/logo.png" alt="Logo" width="150px">
            <img class="logo-fold" src="assets/images/logo/logo_ico.png" alt="Logo" width="30px">
        </a>
    </div>
    <div class="logo logo-white">
        <a [routerLink]="'dashboard/home'">
            <img src="assets/images/logo/logo.png" alt="Logo">
            <img class="logo-fold" src="assets/images/logo/logo_ico.png" alt="Logo" width="40px">
        </a>
    </div>
    <div class="nav-wrap">
        <ul class="nav-left">
            <li class="desktop-toggle">
                <a (click)="toggleFold()">
                    <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" theme="outline"></i>
                </a>
            </li>
            <li class="mobile-toggle">
                <a (click)="toggleExpand()">
                    <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" theme="outline"></i>
                </a>
            </li>
        </ul>
        <ul class="nav-right">
          <li class="flex justify-center items-center">
            <a (click)="logout()">
              <i nz-icon nzType="logout" nzTheme="outline"></i>
            </a>
          </li>
        </ul>
    </div>
</div>
